import e from "@dialpad/dialtone-tokens/layered/themes/tokens-wineberry-colors.css?inline";
//#region themes/wineberry.js
var t = {
	brand: {
		css: e,
		name: "wineberry"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
